import { useAuthContext } from '../context/AuthProvider';

export const useAuth = () => {
    const context = useAuthContext();
    return context;
};
